:host {
  display: block;
  position: absolute;
  top:8px;
  left:8px;
  z-index:9;
}

input {
  height: 28px;
  border: 0;
  margin: 0;
  font-size: 14px;
  padding: 8px;
  outline: 0;
  width: 240px;
  box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1);
}

results {
  display: flex;
  flex-direction: column;
}

result{
  font-size: 12px;
  background: var(--grey-10);
  padding: 4px;
  max-width: 240px;
}

result.focus{
  background-color: var(--grey-30);
}

result:hover{
  background-color: var(--grey-20);
  cursor: pointer;
}